var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "order"
  }, [_c('div', {
    staticClass: "flex gap-5 justify-between items-center mb-6 mdmax:flex-col"
  }, [_c('div', {
    staticClass: "w-3/5 flex gap-5 justify-between mdmax:w-full mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 block"
  }, [_vm._v("Logistik")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedDeliveryService,
      expression: "selectedDeliveryService"
    }],
    staticClass: "w-full pl-2 rounded-lg border-neutral-300 border outline-none text-sm text-neutral-500",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selectedDeliveryService = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, function ($event) {
        return _vm.refetch();
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v("Semua")]), _vm._l(_vm.deliveryServices, function (item, index) {
    return _c('option', {
      key: 'item' + index,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  })], 2)]), _c('div', {
    staticClass: "flex-1"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Pencarian")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "withIcon": true,
      "placeholder": "Cari nomor awb"
    },
    on: {
      "enter": function ($event) {
        return _vm.doSearch();
      }
    },
    model: {
      value: _vm.keyword,
      callback: function ($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1)], 1)])])]), _c('div', {
    staticClass: "bg-white"
  }, [_vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {}, _vm._l(_vm.filteredData, function (order) {
    return _c('div', {
      key: order.id
    }, [_c('OrderCard', {
      attrs: {
        "data": order,
        "insufficientPayment": ""
      }
    })], 1);
  }), 0) : _c('div', {
    staticClass: "py-10 text-center"
  }, [_vm._v(" Data tidak ditemukan! ")])]), !_vm.isMobile && _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "text-neutral-500 font-medium mt-2 text-sm"
  }, [_vm._v("Menampilkan " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " dari " + _vm._s(_vm.totalRecords))]) : _vm._e(), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-center items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.pageSize
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }